"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/LogoHolder/index.js";
var defaultProps = {
  width: "80px",
  height: "80px",
  className: "bg-dark",
  textClassName: "text-white",
  name: "",
  alt: "logo"
};
function LogoHolder(_ref) {
  var className = _ref.className,
    textClassName = _ref.textClassName,
    name = _ref.name,
    logo = _ref.logo,
    width = _ref.width,
    height = _ref.height,
    alt = _ref.alt;
  var _char = name.charAt(0).toUpperCase();
  var style = {
    width: width,
    height: height
  };
  if (logo === undefined) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "d-flex justify-content-center",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 13
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classNames["default"])(className, "rounded-circle d-flex align-items-center justify-content-center"),
      style: style,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 17
      }
    }, /*#__PURE__*/_react["default"].createElement("h1", {
      className: (0, _classNames["default"])(textClassName, "fw-bold m-0 align-middle"),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 21
      }
    }, _char)));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-inline-block",
    style: style,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "w-100 h-100 rounded-circle img-thumbnail p-0",
    src: logo,
    style: {
      objectfit: "cover"
    },
    alt: alt,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 13
    }
  }));
}
LogoHolder.defaultProps = defaultProps;
var _default = exports["default"] = LogoHolder;